import React, {
  createContext,
  useState,
  useContext,
  useMemo,
} from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

export const InitLoadContext = createContext();

export const useInitLoadContext = () => useContext(InitLoadContext) || {};

export const InitLoadProvider = ({ children }) => {
  const [dataLoaded, setDataLoaded] = useState(true);

  const memo = useMemo(() => ({ dataLoading: !dataLoaded }), [dataLoaded]);

  return (
      <InitLoadContext.Provider
        value={{
          ...memo,
          dataLoadingCallback: () => {
            setDataLoaded(false);
            return () => setDataLoaded(true);
          },
        }}>
        {children}
      </InitLoadContext.Provider>
  );
};

InitLoadProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
};
